import { HomePage } from "../components/sagrada/pages/home/HomePage";

export default HomePage;
